import { verifyObject } from '../utils';

const maxFileSize = parseInt(process.env.REACT_APP_MAX_FILE_SIZE, 10) || 5_242_880;
const maxVideoSize = parseInt(process.env.REACT_APP_MAX_VIDEO_SIZE, 10) || 10_485_760;

const config = {
  env: process.env.REACT_APP_STAGE || 'production',
  encryption: {
    secret: process.env.REACT_APP_ENCRYPTION_SECRET as string,
  },
  api: {
    url: process.env.REACT_APP_API_URL ?? '',
    webdbUrl: process.env.REACT_APP_WEBDB_URL ?? '',
    webdbKeyStorage: 'x2KDEnhTH',
    webdbStorage: 'v2LHmBeD5VFXK',
  },
  auth: {
    // TODO: encrypt the key of cookie
    cookieName: 'ksPw4FSNZW',
    webdbApiKey: process.env.REACT_APP_WEBDB_API_KEY ?? '',
  },
  defaultImageUrl: 'common/images/sample_image_20230927.jpg',
  image: {
    maxFileSize,
    maxFileSizeInMb: maxFileSize / 1_024 / 1_024,
  },
  video: {
    maxVideoSize,
    maxVideoSizeInMb: maxVideoSize / 1_024 / 1_024,
  },
};

// Check if config object is valid and not missing a key
const validate = verifyObject(config);

if (!validate) {
  throw new Error('No valid environment found');
}
if (validate.length !== 0) {
  throw new Error(`Environment variable missing: ${validate}`);
}

export default config;
